export default __webpack_public_path__ + "static/media/30-day-ab.45ef8e42.jpeg";